module.exports = __webpack_public_path__ + "82058dae974cbd9f285da2870757f3cb.jpg";